import { del, get, post, put } from "../api"
import * as url from "./urls"

const getMe = () => {
  return get(url.GET_ME)
}

const getProfile = id => {
  return get(url.GET_PROFILE.replace(":id", id))
}

const searchUser = (query = "", offset = 0, limit = 30) => {
  return get(url.SEARCH_USERS, {
    params: {
      q: query,
      offset,
      limit,
    },
  })
}

const getListUsers = (query = "") => {
  return get(url.LIST_USERS, {
    params: {
      q: query,
    },
  })
}

const getListUsersOptions = () => {
  return get(url.GET_LIST_OPTIONS)
}

const createUser = user => {
  return post(url.CREATE_USER, {
    user: {
      name: user.name,
      email: user.email,
      login: user.login,
      documentId: user?.documentId,
      roleId: user.role,
      isMfaEnabled: user.isMfaEnabled,
      // channelId: user.channel,
    },
  })
}

const createMultipleUsers = (roleId, list) => {
  return post(url.CREATE_MULTIPLE_USERS, {
    usersData: list,
    roleId,
    // channelId,
  })
}

const resetPassword = id => {
  const endpoint = url.RESET_PASSWORD.replace(":id", id)
  return get(endpoint)
}

const updateUser = (id, user) => {
  const endpoint = url.UPDATE_USER.replace(":id", id)
  return post(endpoint, {
    user: {
      name: user.name,
      email: user.email,
      login: user.login,
      documentId: user.documentId,
      roleId: user.role,
      isMfaEnabled: user.isMfaEnabled,
    },
  })
}

const removeUser = id => {
  const endpoint = url.REMOVE_SER.replace(":id", id)
  return post(endpoint)
}

const getRoles = () => {
  return get(url.GET_ROLES)
}

const searchRoles = (query = "", offset = 0, limit = 30) => {
  return get(url.GET_ROLES, {
    params: {
      q: query,
      offset,
      limit,
    },
  })
}

const findRoleByName = name => {
  const endpoint = url.FIND_ROLE_BY_NAME.replace(":name", name)
  return get(endpoint)
}

const findRoleById = id => {
  const endpoint = url.FIND_ROLE_BY_ID.replace(":id", id)
  return get(endpoint)
}

const createRole = (name, permissions) => {
  return post(url.GET_ROLES, { name, permissions })
}

const removeRole = id => {
  const endpoint = url.DELETE_ROLE.replace(":id", id)
  return del(endpoint)
}

const updateRole = (id, name, permissions) => {
  const endpoint = url.UPDATE_ROLE.replace(":id", id)
  return put(endpoint, { id, name, permissions })
}

const getPermissions = () => {
  return get(url.GET_PERMISSIONS)
}

const resetUser2FA = id => {
  const endpoint = url.RESET_2FA.replace(":id", id)
  return post(endpoint)
}

const pingServer = pathname => {
  return post(url.POST_PING_ME, { lastScreen: pathname })
}

export {
  searchUser,
  getListUsers,
  getRoles,
  searchRoles,
  createUser,
  createMultipleUsers,
  resetPassword,
  removeUser,
  updateUser,
  getPermissions,
  findRoleByName,
  findRoleById,
  createRole,
  removeRole,
  updateRole,
  getListUsersOptions,
  resetUser2FA,
  getMe,
  pingServer,
  getProfile,
}
